import {COLORS} from '../utils/style-variables';

export const TEXT = {
  defaultSize: {
    fontSize: '15px',
    lineHeight: 1.35
  }
};

export const HEADING = {
  heading2: {
    fontWeight: 'bold',
    fontSize: '25px',
    lineHeight: 1.2
  },
  heading3: {
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: 1.25
  },
  heading4: {
    fontWeight: 'bold',
    fontSize: '17px',
    lineHeight: 1.2
  }
};

export const LINKS = {
  defaultLink: {
    color: COLORS.mainBlueColor,
    textDecoration: 'none',
    borderBottom: `1px dashed ${COLORS.mainBlueColor}`,
    cursor: 'pointer',
    ...TEXT.defaultSize
  }
};

export const TEXT_ALIGN = {
  left: {
    textAlign: 'left'
  },
  right: {
    textAlign: 'right'
  },
  center: {
    textAlign: 'center'
  }
};
